import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { IHttpMoveImagePayload } from '../../../action/http.action';

export const httpMoveImage = (imageId: string, folderId: string, oldFolderId: string) => returnAction<IHttpMoveImagePayload>(ActionEnum.HTTP_MOVE_IMAGE, {
  imageId,
  folderId,
  oldFolderId
});
